import { render, staticRenderFns } from "./ApprovalsTable.vue?vue&type=template&id=1478216a&scoped=true&"
import script from "./ApprovalsTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalsTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalsTable.vue?vue&type=style&index=0&id=1478216a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478216a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1478216a')) {
      api.createRecord('1478216a', component.options)
    } else {
      api.reload('1478216a', component.options)
    }
    module.hot.accept("./ApprovalsTable.vue?vue&type=template&id=1478216a&scoped=true&", function () {
      api.rerender('1478216a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/ApprovalsTable.vue"
export default component.exports